import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

type SidebarAccountMenuProps = {
  onProfile: () => void;
  onLogout: () => void;
};

const SidebarAccountMenu = ({ onProfile, onLogout }: SidebarAccountMenuProps) => (
  <div className="sidebar-account-menu">
    <button
      type="button"
      className="sidebar-account-menu__item"
      onClick={onProfile}
    >
      <UserOutlined />
      <span>Hồ sơ</span>
    </button>
    <button
      type="button"
      className="sidebar-account-menu__item"
      onClick={onLogout}
    >
      <LogoutOutlined />
      <span>Đăng xuất</span>
    </button>
  </div>
);

export default SidebarAccountMenu;
